import PageHeader from '~/components/PageHeader';
import Stack from '~/components/ui/Stack';

// import useActiveSubscription from '~/modules/subscription/useActiveSubscription';

function SubscriptionUpgrade() {
  // const activePlan = useActiveSubscription();

  return (
    <Stack col gap={6} className="flex-1">
      <PageHeader id="upgradeSubscription" />

      <div>111</div>
    </Stack>
  );
}

export default SubscriptionUpgrade;
